// all_zoom_setting 데이터 구조 정의
export const defaultZoomSettings = {
  allowRanking: 30,
  adminNotification: [1],
  depositAccount: "",
  invoiceAccount: "",
  contactInfo: "",
  kakaoChannelId: "",
  end_submit: "17:00", // 주문 마감 시간 (기본값: 17:00)
  defaultAdRates: {
    banner: 0,
    popup: 0,
    video: 0,
  },
};

// 데이터 유효성 검사 함수
export const validateZoomSettings = (data) => {
  if (!data) return false;

  const requiredFields = [
    "allowRanking",
    "adminNotification",
    "depositAccount",
    "invoiceAccount",
    "contactInfo",
    "kakaoChannelId",
    "end_submit", // 주문 마감 시간 필드 추가
    "defaultAdRates",
  ];

  // 필수 필드 존재 여부 확인 (값이 없어도 필드 자체는 있어야 함)
  for (const field of requiredFields) {
    if (data[field] === undefined || data[field] === null) {
      return false;
    }
  }

  // end_submit 시간 형식 검증 (HH:MM 형식)
  if (data.end_submit && typeof data.end_submit === "string") {
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    if (!timeRegex.test(data.end_submit)) {
      return false;
    }
  }

  // defaultAdRates 객체 확인 (빈 객체여도 허용)
  if (!data.defaultAdRates || typeof data.defaultAdRates !== "object") {
    return false;
  }

  // adminNotification 배열 확인 및 각 요소가 정수인지 검증
  if (!Array.isArray(data.adminNotification)) {
    return false;
  }

  // adminNotification 배열의 각 요소가 정수인지 확인
  for (const notificationId of data.adminNotification) {
    if (!Number.isInteger(notificationId)) {
      return false;
    }
  }

  return true;
};

// 주문 마감 시간 관련 유틸리티 함수들
export const timeUtils = {
  // 현재 시간이 마감 시간을 지났는지 확인
  isSubmitTimeExpired: (endSubmitTime) => {
    if (!endSubmitTime) return false;

    const now = new Date();
    const currentTime = `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;

    return currentTime >= endSubmitTime;
  },

  // 마감 시간까지 남은 시간 계산 (분 단위)
  getRemainingMinutes: (endSubmitTime) => {
    if (!endSubmitTime) return 0;

    const now = new Date();
    const [deadlineHour, deadlineMinute] = endSubmitTime.split(":").map(Number);
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const deadlineTotalMinutes = deadlineHour * 60 + deadlineMinute;
    const currentTotalMinutes = currentHour * 60 + currentMinute;

    if (currentTotalMinutes >= deadlineTotalMinutes) {
      return 0; // 이미 만료됨
    }

    return deadlineTotalMinutes - currentTotalMinutes;
  },

  // 남은 시간을 HH:MM 형식으로 포맷팅
  formatRemainingTime: (endSubmitTime) => {
    const remainingMinutes = timeUtils.getRemainingMinutes(endSubmitTime);
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    return `${String(hours).padStart(2, "0")} : ${String(minutes).padStart(
      2,
      "0"
    )}`;
  },

  // 현재 시간 가져오기
  getCurrentTime: () => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;
  },
};
